import { useEffect, useState } from "react";

export const useCurrentTime = (videoElement: HTMLVideoElement | null) => {
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    if (!videoElement) return;

    const updateCurrentTime = () => {
      setCurrentTime(videoElement.currentTime);
    };

    videoElement.addEventListener("timeupdate", updateCurrentTime);

    return () => {
      videoElement.removeEventListener("timeupdate", updateCurrentTime);
    };
  }, [videoElement]);

  return currentTime;
}

export const useDuration = (videoElement: HTMLVideoElement | null) => {
  const [duration, setDuration] = useState(0);

  useEffect(() => {

    console.log('### video element', videoElement);
    if (!videoElement) return;

    const updateDuration = () => {
      if (!isNaN(videoElement.duration)) {
        setDuration(videoElement.duration);
      }
    };

    videoElement.addEventListener("canplay", updateDuration);

    return () => {
      videoElement.removeEventListener("canplay", updateDuration);
    };
  }, [videoElement]);

  return duration;
}

export const useBuffered = (videoElement: HTMLVideoElement | null) => {
  const [buffered, setBuffered] = useState<TimeRanges>();

  useEffect(() => {
    if (!videoElement) return;

    const updateBuffered = () => {
      setBuffered(videoElement.buffered);
    };

    videoElement.addEventListener("progress", updateBuffered);
    videoElement.addEventListener("loadedmetadata", updateBuffered);

    return () => {
      videoElement.removeEventListener("progress", updateBuffered);
      videoElement.removeEventListener("loadedmetadata", updateBuffered);
    };
  }, [videoElement]);

  return buffered;
}